// styles
import {
  InputTextfieldContainer,
  InputTextfield as StyledInputTextfield,
  InputLabel
} from './InputTextfield.styles.js';

export default function InputTextfield({ pH="", value, updateValue, id, label, rows = 3, maxLength, ...otherProps }) {

  return (
      <InputTextfieldContainer>
          <StyledInputTextfield
              className='panel-bg'
              onChange={(e) => updateValue?.(e.target.value)}
              placeholder=" "
              value={value}
              id={id}
              rows={rows}
              maxLength={maxLength}
              {...otherProps}
          />
          <InputLabel htmlFor={id}>
              {label || pH}
          </InputLabel>
      </InputTextfieldContainer>
  )
}
